<template>
  <div class="controlbox">
    <div class="control-search">
      <el-input
        placeholder="请输入设备名称"
        v-model="deviceName"
        class="input-with-select"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="getList"
        ></el-button>
      </el-input>
    </div>
    <div class="control-content">
      <div class="control-panel_box">
        <div
          class="panel-item"
          v-for="(item, index) in lightAllList"
          :key="index"
        >
          <div class="item-box">
            <div
              :class="{
                'item-img-light-gray':
                  item.activeStatus === '0' || item.activeStatus === null,
                'item-img-light-green': item.activeStatus === '1',
                'item-img-light-red': item.onlineStatus === '2',
              }"
            ></div>
            <div class="item-font">{{ item.equipmentName }}</div>
          </div>
          <div class="item-switch">
            <el-switch
              v-model="item.activeStatus"
              active-color="#298beb"
              inactive-color="#a0a8b5"
              active-value="1"
              inactive-value="0"
              :disabled="item.onlineStatus === '2'"
              @change="controlChange($event, item.equipmentCode)"
            >
            </el-switch>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getEquipmentCode,
  listEquipment,
  controlDevice,
} from "@/api/src/equipment";
export default {
  name: "LightPanelView",
  components: {},
  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {
    deviceList: {
      type: Array,
    },
    areaCode: {
      type: String,
    },
  },

  data() {
    return {
      loadingText: "加载中...",
      equipList: this.deviceList,
      //设备信息
      lightAllList: [],
      value: true,
      regionCode: this.areaCode,
      code: null,
      deviceName: null,
      offLine: false, //是否全部离线
    };
  },
  watch: {
    deviceList(newVal) {
      this.equipList = newVal; //对父组件传过来的值进行监听，如果改变也对子组件内部的值进行改变
    },
    areaCode(newVal) {
      if (newVal === "0") newVal = null;
      this.regionCode = newVal; //对父组件传过来的值进行监听，如果改变也对子组件内部的值进行改变
      this.getList();
    },
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    // 获取设备code
    init() {
      getEquipmentCode("lightEquipment").then((response) => {
        this.code = response.data;
        this.getList();
      });
    },
    // 查询
    getList() {
      this.loading = true;

      listEquipment({
        categoryCode: this.code,
        areaCode: this.regionCode,
        equipmentName: this.deviceName,
        pageSize: 10000,
      }).then((response) => {
        this.lightAllList = response.rows;

        this.loading = false;
      });
    },

    //单个设备开关变化
    controlChange(val, equipmentCode) {
      if (val === "1") {
        this.open(equipmentCode);
      } else {
        this.close(equipmentCode);
      }
    },
    //打开
    open(equipmentCode) {
      this.$confirm("确定要打开吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.controlDevice("2", equipmentCode); //instructions指令 2 开 1 关

          this.loading = true;
          this.loadingText = "打开中...";
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消打开",
          });
          this.getList();
        });
    },
    //关闭
    close(equipmentCode) {
      this.$confirm("确定要关闭吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.loadingText = "关闭中...";
          this.controlDevice("1", equipmentCode); //instructions指令 2 开 1 关
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消关闭",
          });
          this.getList();
        });
    },
    //智能控制
    controlDevice(instructions, equipmentCode) {
      let paramData = {
        // areaCode: null, //全开，全关的话， areaCode就传那个分区code;
        //categoryCode: null, //单个的， categoryCode和areaCode不用传
        instructions: instructions, //指令 2 开 1 关
        equipmentCode: equipmentCode, //全部的话equipmentCode不用传
      };
      controlDevice(paramData)
        .then((response) => {
          this.$message({
            type: "success",
            message: instructions === "2" ? "打开成功" : "关闭成功",
          });
          //更新设备状态
          this.getList();
        })
        .catch((err) => {
          console.log(err);
          this.getList();
        });
    },
  },
};
</script>